/**
 * @generated SignedSource<<033b1cad6a521cfa1884677a6ab4c4de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type UpdateOrganizationInput = {
  organizationId: string;
  updateOrganizationData: UpdateOrganizationData;
  clientMutationId?: string | null;
};
export type UpdateOrganizationData = {
  name?: string | null;
  email?: string | null;
  city?: string | null;
  organizationConfigAttributes?: UpdateOrganizationConfigData | null;
  state?: string | null;
};
export type UpdateOrganizationConfigData = {
  daysBeforeDueSoon?: number | null;
  daysBeforeOverdue?: number | null;
};
export type organizationSettingsMutation$variables = {
  input: UpdateOrganizationInput;
};
export type organizationSettingsMutationVariables = organizationSettingsMutation$variables;
export type organizationSettingsMutation$data = {
  readonly updateOrganization: {
    readonly organization: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
      readonly email: string;
      readonly city: string;
      readonly state: string;
      readonly organizationConfig: {
        readonly daysBeforeDueSoon: number;
        readonly daysBeforeOverdue: number;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
    }>;
  } | null;
};
export type organizationSettingsMutationResponse = organizationSettingsMutation$data;
export type organizationSettingsMutation = {
  variables: organizationSettingsMutationVariables;
  response: organizationSettingsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysBeforeDueSoon",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysBeforeOverdue",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UserError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "organizationSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrganizationPayload",
        "kind": "LinkedField",
        "name": "updateOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationConfig",
                "kind": "LinkedField",
                "name": "organizationConfig",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "organizationSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrganizationPayload",
        "kind": "LinkedField",
        "name": "updateOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationConfig",
                "kind": "LinkedField",
                "name": "organizationConfig",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea67f898c6cf58c067e22770d1c25a3d",
    "id": null,
    "metadata": {},
    "name": "organizationSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation organizationSettingsMutation(\n  $input: UpdateOrganizationInput!\n) {\n  updateOrganization(input: $input) {\n    organization {\n      id\n      createdAt\n      name\n      email\n      city\n      state\n      organizationConfig {\n        daysBeforeDueSoon\n        daysBeforeOverdue\n        id\n      }\n    }\n    errors {\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e378855ba6ee06677de235b98428e3f";

export default node;
